import Quill from 'quill';

const embedBlotName = 'addVideo';
const BlockEmbedHtml = Quill.import('blots/block/embed');

class EmbedHtmlBlot extends BlockEmbedHtml {
  static create({ videoSrc, videoEmbed, shortId }) {
    const node = super.create();

    node.setAttribute('class', 'video-iframe-wrapper relative custom-ql-video');
    node.setAttribute('id', `blot-custom-id---${shortId}`);
    node.innerHTML = `<div>${videoEmbed}</div>`;

    return node;
  }

  static value(node) {
    return { videoEmbed: node.innerHTML, shortId: node.id.split('---').at(-1) };
  }
}

EmbedHtmlBlot.blotName = embedBlotName;
EmbedHtmlBlot.tagName = 'div';
Quill.register(EmbedHtmlBlot);
